<template>
    <div class="topbar-item">

        <div class="btn btn-icon btn-hover-transparent-white d-flex align-items-center btn-lg px-md-2 w-md-auto"
             id="kt_quick_user_toggle">
            <span class="text-white opacity-70 font-weight-bold font-size-base d-none d-md-inline mr-1">Hi,</span>
            <span class="text-white opacity-90 font-weight-bolder font-size-base d-none d-md-inline mr-4"> {{ user.name }} </span>
            <span>
                <img :src="user.photoUrl" alt="avatar" class="rounded-sm" width="30"/>
            </span>
        </div>

        <div class="offcanvas offcanvas-right p-10" id="kt_quick_user" ref="kt_quick_user">
            <div class="offcanvas-header d-flex align-items-center justify-content-between pb-5">
                <h3 class="font-weight-bold m-0">User Profile</h3>
                <a class="btn btn-xs btn-icon btn-light btn-hover-primary" href="#" id="kt_quick_user_close">
                    <i class="ki ki-close icon-xs text-muted"></i>
                </a>
            </div>

            <!--begin::Content-->
            <perfect-scrollbar class="offcanvas-content pr-5 mr-n5 scroll"
                               style="max-height: 90vh; position: relative;">
                <!--begin::Header-->
                <div class="d-flex align-items-center mt-5">
                    <div class="symbol symbol-100 mr-5">
                        <img :src="user.photoUrl" alt="user profile" class="symbol-label"/>
                        <i class="symbol-badge bg-success"></i>
                    </div>
                    <div class="d-flex flex-column">
                        <a class="font-weight-bold font-size-h5 text-dark-75 text-hover-primary" href="#">{{ user.name
                            }}</a>
                        <div class="navi mt-2">
                            <a class="navi-item" href="#">
                                <span class="navi-link p-0 pb-2">
                                    <span class="navi-icon mr-1">
                                        <span class="svg-icon svg-icon-lg svg-icon-primary">
                                            <!--begin::Svg Icon-->
                                            <inline-svg src="media/svg/icons/Communication/Mail-notification.svg"/>
                                            <!--end::Svg Icon-->
                                        </span>
                                    </span>
                                    <span class="navi-text text-muted text-hover-primary">{{ user.email }}</span>
                                </span>
                            </a>
                        </div>
                        <button @click="onLogout" class="btn btn-light-primary btn-bold">Sign out</button>
                    </div>
                </div>
                <!--end::Header-->

                <div class="separator separator-dashed mt-8 mb-5"></div>

                <!--begin::Nav-->
                <div class="navi navi-spacer-x-0 p-0">
                    <!--begin::Item-->
                    <router-link @click.native="closeOffcanvas" class="navi-item" href="#" to="/builder">
                        <div class="navi-link">
                            <div class="symbol symbol-40 bg-light mr-3">
                                <div class="symbol-label">
                                    <span class="svg-icon svg-icon-md svg-icon-success">
                                        <!--begin::Svg Icon-->
                                        <inline-svg src="media/svg/icons/General/Notification2.svg"/>
                                        <!--end::Svg Icon-->
                                    </span>
                                </div>
                            </div>
                            <div class="navi-text">
                                <div class="font-weight-bold">My Profile</div>
                                <div class="text-muted">Account settings and more</div>
                            </div>
                        </div>
                    </router-link>
                    <!--end:Item-->
                </div>
                <!--end::Nav-->

                <div class="separator separator-dashed my-7"></div>

                <!--begin::Activities-->
                <div>
                    <!--begin:Heading-->
                    <h5 class="mb-5">Recent Activities</h5>
                    <!--end:Heading-->
                    <template v-for="(item, i) in list">
                        <!--begin::Item -->
                        <div class="d-flex align-items-center rounded p-5 gutter-b"
                             v-bind:class="`bg-light-${item.type}`" v-bind:key="i">
                            <span class="svg-icon mr-5" v-bind:class="`svg-icon-${item.type}`">
                                <span class="svg-icon svg-icon-lg">
                                    <!--begin::Svg Icon-->
                                    <inline-svg :src="item.svg"/>
                                    <!--end::Svg Icon-->
                                </span>
                            </span>
                            <div class="d-flex flex-column flex-grow-1 mr-2">
                                <a class="font-weight-normal text-dark-75 text-hover-primary font-size-lg mb-1"
                                   href="#">
                                    {{ item.title }}
                                </a>
                                <span class="text-muted font-size-sm">{{ item.desc }}</span>
                            </div>
                            <span class="font-weight-bolder py-1 font-size-lg" v-bind:class="`text-${item.type}`">{{ item.alt }}
                            </span>
                        </div>
                        <!--end::Item -->
                    </template>
                </div>
                <!--end::Activities-->

            </perfect-scrollbar>
            <!--end::Content-->
        </div>
    </div>
</template>

<style lang="scss" scoped>
    #kt_quick_user {
        overflow: hidden;
    }
</style>

<script>

   import {mapGetters} from 'vuex';
   import {SIGNOUT} from "@/core/store/modules/auth";
   import KTLayoutQuickUser from "@/assets/js/layout/extended/quick-user.js";
   import KTOffcanvas from "@/assets/js/components/offcanvas.js";

   export default {
      name: "KTQuickUser",
      data() {
         return {
            list: [
               {
                  title: "Create reports",
                  desc: "10:39 PM",
                  alt: "30/10/2020",
                  svg: "media/svg/icons/Communication/Write.svg",
                  type: "success"
               },
               {
                  title: "Verify Report",
                  desc: "30/10/2020",
                  alt: "10:39 PM",
                  svg: "media/svg/icons/Communication/Write.svg",
                  type: "info"
               }
            ]
         };
      },
      mounted() {
         // Init Quick User Panel
         KTLayoutQuickUser.init(this.$refs["kt_quick_user"]);
      },
      methods: {
         onLogout() {
            this.$store
                .dispatch(SIGNOUT)
                .then(() => this.$router.push({name: "login"}));
         },
         closeOffcanvas() {
            new KTOffcanvas(KTLayoutQuickUser.getElement()).hide();
         }
      },
      computed: {
         ...mapGetters([
            'user'
         ]),
         picture() {
            return process.env.BASE_URL + "media/users/300_21.jpg";
         }
      }
   };
</script>
